module.exports = __webpack_public_path__ + "img/menu.9d84b973.svg";